<template>
    <div>
        <Header />
        <Banner />
        <router-view />
        <Footer />
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Banner from '@/components/Banner'
    export default {
        data () {
            return {
            }
        },
        mounted () {
        },
        methods: {
            
        },
        components: {
            Header,
            Banner,
            Footer
        }
    }
</script>